const AUDIENCE_LIST_PAGE_SIZE = 25;
const AUDIENCE_LIST_INITIAL_PAGE = 1;
const DATE_TIME_FORMAT = 'MM/DD/YY h:mm a';
const LARGE_AUDIENCE_LIST_PAGE_SIZE = 10000;

export { AUDIENCE_LIST_PAGE_SIZE, AUDIENCE_LIST_INITIAL_PAGE, DATE_TIME_FORMAT, LARGE_AUDIENCE_LIST_PAGE_SIZE };